<template>
	<div id="quote-requested-success-template">
		<appCreateProgressBar />
		<div class="quote-requested-success-inner">
			<div class="box col sm-8 md-6 lg-6">
				<div class="success-roundel"></div>
				<div class="quote-requested-success__title">Thank you, your quotation will be with you shortly.</div>
				<div class="quote-requested-success__subhead">We'll email you when your quote is ready, or get in touch with any queries.</div>
				<div class="quote-requested-success__img">
					<img src="@/assets/images/img__quote-success.png" style="max-width:160px">
				</div>
				<div class="pwer-by-title">Powered by</div>
				<div class="pwer-by-success-img">
					<a href="https://mapitapp.co.uk/" target="_blank"><img src="@/assets/images/MapitApp-logo-blue.svg" style="max-width:160px"></a>
				</div>
				<div class="pwer-by-subtitle"><a href="https://mapitapp.co.uk/" target="_blank">Start a free trial here</a></div>
			</div>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';
import QuoteRequestedSuccessModal from '../common/Modals/QuoteRequestedSuccessModal';

export default {
	data(){
		return {
			

		}
	},
	components : {
		appCreateProgressBar : CreateProgressBar,
		QuoteRequestedSuccessModal : QuoteRequestedSuccessModal
	},
	computed : {
		
	},
	methods : {
		goToMyAccount(){
			this.$router.push({path : '/dashboard'});
		}
	},

	created(){
		this.$store.dispatch('setIsWaiting', {isWaiting : false, message : ''});
	}

}
</script>



// WEBPACK FOOTER //
// src/components/pages/QuoteRequestedSuccess.vue